import { render, staticRenderFns } from "./AddPlatformtemplateWholesaler.vue?vue&type=template&id=3fc86394&"
import script from "./AddPlatformtemplateWholesaler.vue?vue&type=script&lang=js&"
export * from "./AddPlatformtemplateWholesaler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports